<template>
  <span class="mktoFormWrapper">
    <form :id="'mktoForm_' + id" :class="className"></form>
    <p v-if="adblockMessage()" class="form-error">
      It looks like we're unable to load our form. To view this form, please
      allow external scripts to load on ShopKeep.com. If you prefer to speak
      with a POS specialist, call us at
      <a href="tel:+1-800-820-9814">1-800-820-9814</a>.
    </p>
  </span>
</template>
<script>
/* globals MktoForms2, dataLayer */
import $ from 'jquery';
import _ from 'underscore';
import skOptimizely from '../../analytics/sk-optimizely';
import mktoSteps from '../../components/sk-marketo-steps';
import mktoAnalytics from '../../twig/vue/components/marketo/marketo-analytics';
import mktoStepsAutofill from '../../twig/vue/components/marketo/marketo-steps-autofill';
import cookies from '../../twig/helpers/cookies';

export default {
  props: [
    'id',
    'cta',
    'redirect',
    'steps',
    'stepsText',
    'confirmMessage',
    'confirmMessageB',
    'confirmRedirect',
    'preventLoad',
    'moveFirst',
    'nonProgressiveFields',
    'className',
    'optimizelyLightbox',
    'optimizelySuccess',
    'optimizelyConfirm',
    'optimizelyPrefix',
    'gaPrefix',
    'binaryOptionEnabled'
  ],
  data() {
    return {
      form: null,
      formIsSet: false,
      stepsIsResumed: false,
      lightboxHasOpened: false,
      binaryHasViewed: false,
      defaultNonProgressive: ['Number_of_Registers__c'],
      moveFirstBack: false,
      setInitialListeners: false,
      step: 1,
      stepsTotal: 0,
      skipSteps: [],
      stepsWithEvents: [],
      readyForFinalSubmit: true
    };
  },

  computed: {
    lightbox() {
      if (!this.$parent.$el) {
        return -1;
      }
      return this.$parent.$el.className
        .split(' ')
        .indexOf('ui-lightbox-wrapper');
    },
    lightboxToggled() {
      return this.$root.lightboxToggled;
    },
    defaultGaEventPrefix() {
      return this.gaPrefix ? `${this.gaPrefix} PSG` : 'PSG';
    }
  },

  methods: {
    adblockMessage() {
      if (typeof MktoForms2 === 'undefined' || MktoForms2.isUndefined) {
        window.MktoForms2 = {
          whenReady: () => {},
          whenRendered: () => {},
          loadForm: () => {},
          isUndefined: true
        };

        window.onload = () => {
          const subheadObj = document.querySelector('header.mktoHeader p');
          const formHeader = document.querySelector('header.mktoHeader h2');
          const formHeaderText =
            formHeader !== null
              ? formHeader.textContent || formHeader.innerText
              : '';
          if (subheadObj !== null) {
            subheadObj.style.display = 'none';
          }
          window.ga(
            'send',
            'event',
            'Ablock Message',
            window.location.pathname,
            formHeaderText
          );
        };
        return true;
      }
      return false;
    },

    setCurrentCTA(currentCTA) {
      this.currentCTA = currentCTA;
    },

    getFormType() {
      if (this.$root.lightboxFormType === 'Timer') {
        return 'Timer';
      }
      return this.lightbox < 0 ? 'Inline' : 'Popup';
    },

    loadForm() {
      const id = this.id;
      const optimizelySuccess = this.optimizelySuccess;
      MktoForms2.loadForm(
        '//app-ab01.marketo.com',
        '169-JJW-529',
        id,
        (form) => {
          if (form.getId() === Number(this.id)) {
            const button = form.getFormElem().find('button');
            const event = this.steps ? this.defaultGaEventPrefix : 'webForm';
            dataLayer.push({
              event,
              formAction: 'Load',
              formId: this.id,
              fieldValue: this.cta,
              formType: this.lightbox < 0 ? 'Inline' : 'Popup'
            });

            if (!this.steps) {
              button.on('click', () => {
                mktoAnalytics.setErrors(form);
              });
            }

            form.onSuccess(() => {
              cookies.setMarketoLead();
              cookies.setMarketoLeadInfo(form);
              if (this.currentCTA) {
                if (this.step > this.stepsTotal) {
                  this.$root.marketoCurrentStepConfirmation = 'Confirmation';
                }
                const stepSubmitted = this.step - 1;
                dataLayer.push({
                  event,
                  formStep: stepSubmitted,
                  formAction: 'Submit',
                  formId: this.id,
                  fieldValue: this.currentCTA,
                  formType: this.getFormType()
                });
              } else {
                dataLayer.push({
                  event,
                  formAction: 'Submit',
                  formId: this.id,
                  fieldValue: this.$root.lightboxCta || this.cta,
                  formType: this.getFormType()
                });
              }
              if (optimizelySuccess) {
                skOptimizely.pushEvent(optimizelySuccess);
              }
            });
          }
        }
      );
    },

    setCta() {
      const form = this.form;
      const cta = this.cta;
      form
        .getFormElem()
        .find('.mktoButton')
        .text(cta);
    },

    setRedirect() {
      const form = this.form;
      const redirect = this.redirect;

      form.onSuccess(() => {
        window.location = redirect;
        return false;
      });
    },

    setConfirmMessage(message) {
      const form = this.form;
      const confirmMessage = `<div class='confirm-message-wrapper'>${message}</div>`;
      const confirmRedirect = this.confirmRedirect;
      const optimizelyConfirm = this.optimizelyConfirm;

      form.onSuccess(() => {
        if (this.readyForFinalSubmit) {
          if (this.lightbox > -1) {
            mktoAnalytics.setVirtualThankYouPage();
          }

          const yPosition = form
            .getFormElem()
            .parent()
            .parent()
            .offset().top;

          form
            .getFormElem()
            .parent()
            .parent()
            .children()
            .not('.ui-lightbox-close')
            .hide();

          form
            .getFormElem()
            .parent()
            .parent()
            .append(confirmMessage);

          window.scrollTo(0, yPosition - 100);

          if ($('.confirm-button, .confirm-image').length) {
            $('.confirm-button, .confirm-image').on('click', () => {
              if (optimizelyConfirm) {
                skOptimizely.pushEvent(optimizelyConfirm);
              }
              window.location.href = confirmRedirect;
            });
          }
        } else {
          const button = form.getFormElem().find('button');
          $(button).removeAttr('disabled');
        }
        return false;
      });
    },

    setToSteps() {
      const id = this.id;
      const form = this.form;
      const prefix = this.optimizelyPrefix;
      const moveFirst = this.moveFirst;
      const nonProgressive = (this.nonProgressiveFields || []).concat(
        this.defaultNonProgressive
      );
      const button = form.getFormElem().find('button');
      const fieldsets = form.getFormElem().find('fieldset');
      this.stepsTotal = fieldsets.length;

      document.getElementById(`mktoForm_${id}`).style.display = 'none';

      this.initSteps(form, fieldsets, button, nonProgressive, id);

      if (moveFirst) {
        $('.move-first-step').css({ height: 'auto', overflow: 'visible' });
      }

      button.on('click', (e) => {
        mktoAnalytics.setErrors(form, this.step);
        if (mktoSteps.inputIsInvalid(fieldsets[this.step - 1], form)) {
          e.preventDefault();
          return;
        }

        if (this.step < this.stepsTotal) {
          e.preventDefault();
        }
        this.resumeSteps(this.$root.marketoInitialStep, this.stepsTotal, e);

        mktoAnalytics.setSteps(
          this.step,
          this.stepsTotal,
          e,
          prefix,
          this.gaPrefix,
          this.id
        );
        this.step += 1;

        if (id === '2342') {
          const currentCTA = e.currentTarget.innerText;
          this.setCurrentCTA(currentCTA);

          if (
            fieldsets[0].querySelector('#In_The_Market_for_a_POS__c').value ===
            'no'
          ) {
            this.setConfirmMessage(this.confirmMessageB);
            this.$root.marketoCurrentStep = this.step;
            this.$root.marketoCurrentStepConfirmation = 'Confirmation';
            form.submit();
            return;
          }
          this.readyForFinalSubmit = this.step === this.stepsTotal + 1;
          form.submit();
        }
        while (this.skipSteps.indexOf(this.step) !== -1) {
          this.step++;
        }
        this.setStep(button, fieldsets, nonProgressive, id);
        if (fieldsets[this.step - 1]) {
          this.$root.marketoCurrentStepId = fieldsets[
            this.step - 1
          ].querySelectorAll('select, input')[0].id;
        }
        this.$root.marketoCurrentStep = this.step;
      });

      this.formIsSet = true;
      this.autofillMultipleForms();
    },

    resumeSteps(initialStep, steps, e) {
      if (initialStep > 1 && !this.$root.marketoStepResumed) {
        const formAction = 'Resume';
        const fieldValue = e.currentTarget.innerText;
        const formStep = initialStep;
        const gaEvent = this.defaultGaEventPrefix;
        dataLayer.push({ event: gaEvent, formAction, fieldValue, formStep });

        this.$root.marketoStepResumed = true;
      }
    },

    moveFirstStep() {
      const vueObj = this;
      const form = this.form;

      $('.move-first-step').css({ height: 0, overflow: 'hidden' });
      vueObj.setToSteps();
      form
        .getFormElem()
        .detach()
        .appendTo('.move-first-step');
      $('.lightbox').on('click', () => {
        this.moveFirstBack = true;
        $(form.getFormElem())
          .detach()
          .appendTo(`.${vueObj.moveFirst}`);
        $('.move-first-step').hide();
        const navUserAgent = navigator.userAgent.toLowerCase();
        if (
          navUserAgent.indexOf('safari') > -1 &&
          navUserAgent.indexOf('chrome') === -1
        ) {
          window.scrollTo(0, window.pageYOffset + 1);
          $(
            `.${vueObj.moveFirst} .mktoButton, .${vueObj.moveFirst} select`
          ).css('position', 'relative');
          $(
            `.${vueObj.moveFirst} .mktoButton, .${vueObj.moveFirst} select`
          ).css('top', '1px');
        }
      });
    },

    setNonSteps() {
      const form = this.form;
      const button = form.getFormElem().find('button');
      this.formIsSet = true;

      button.on('click', (e) => {
        mktoAnalytics.setErrors(form);
        if (mktoSteps.inputIsInvalid(form.getFormElem()[0], form)) {
          e.preventDefault();
          return;
        }
      });
    },

    autofillMultipleForms() {
      if (!this.steps || this.$root.marketoCountForms <= 1) {
        return;
      }

      const form = this.form;
      const nonProgressive = (this.nonProgressiveFields || []).concat(
        this.defaultNonProgressive
      );
      const button = form.getFormElem().find('button');
      const fieldsets = form.getFormElem().find('fieldset');
      this.$root.connectedMarketoForms = true;
      this.stepsTotal = fieldsets.length;

      this.initSteps(form, fieldsets, button, nonProgressive, this.id);

      if (!this.setInitialListeners) {
        const selects = fieldsets[this.step - 1].querySelectorAll('select');
        const inputs = fieldsets[this.step - 1].querySelectorAll('input');

        _.each(selects, (select) => {
          select.addEventListener(
            'change',
            this.listenFirstChange(this.step, fieldsets)
          );
        });

        _.each(inputs, (input) => {
          input.addEventListener(
            'change',
            this.listenFirstChange(this.step, fieldsets)
          );
        });

        this.setInitialListeners = true;
      }
    },

    listenFirstChange(step, fieldsets) {
      return () => {
        if (!this.$root.marketoFormChanged) {
          this.$root.marketoCurrentStepId = fieldsets[
            step - 1
          ].querySelectorAll('select, input')[0].id;
          this.$root.marketoFormChanged = true;
        }
      };
    },

    initSteps(form, fieldsets, button, nonProgressive, id) {
      // form 2143 is a partners step lead, autofill is only a marketing functionality
      if (id !== 2143) {
        this.skipSteps = mktoStepsAutofill.call(
          this,
          form,
          this.stepsTotal,
          fieldsets
        );
      }
      while (this.skipSteps.indexOf(this.step) !== -1) {
        this.step++;
      }
      this.$root.marketoInitialStep = this.step;

      if (!this.moveFirst || this.moveFirstBack) {
        this.setStep(button, fieldsets, nonProgressive, id);
      } else {
        MktoForms2.whenReady((mktoForm) => {
          if (mktoForm.getId() === Number(this.id)) {
            this.form = form;
            this.setStep(button, fieldsets, nonProgressive, id);
          }
        });
      }

      document.getElementById(`mktoForm_${id}`).style.display = 'block';
    },

    setStep(button, fieldsets, nonProgressive, id) {
      if (fieldsets[this.step - 1]) {
        const firstField = fieldsets[this.step - 1].querySelectorAll(
          'select, input'
        )[0];

        if (
          firstField.id === 'Business_Category__c' &&
          fieldsets[this.step - 1].querySelector('#Business_Category_Type__c')
            .value === ''
        ) {
          mktoSteps.setOptions.call(this, this.step, fieldsets, firstField);
        }
      }

      mktoSteps.setHash(this.step, this.stepsTotal);
      mktoSteps.setTextChange(
        this.step,
        this.stepsTotal,
        button,
        this.stepsText,
        this.cta,
        id
      );
      mktoSteps.setFieldsets(this.step, fieldsets, nonProgressive);

      if (!_.contains(this.stepsWithEvents, this.step)) {
        mktoSteps.inputChange.call(
          this,
          this.step,
          fieldsets,
          this.optimizelyPrefix,
          this.gaPrefix
        );
        this.stepsWithEvents.push(this.step);
      }
    },

    initLightboxToggled() {
      if (this.binaryOptionEnabled === 'true' && !this.binaryHasViewed) {
        this.$root.binaryOptionVisible = true;
        // this.binaryHasViewed = true;
      }
      if (this.lightbox > -1 && !this.lightboxHasOpened) {
        if (
          this.optimizelyLightbox &&
          this.optimizelyLightbox !== 'navTest-Click'
        ) {
          const optimizelyEvents = this.optimizelyLightbox.split(',');
          skOptimizely.allocateEvents(optimizelyEvents, false);
        }
        this.lightboxHasOpened = true;
      }
      if (this.lightboxToggled.indexOf('lightboxMarketo') > -1) {
        if (this.lightbox > -1 && this.steps && this.formIsSet === false) {
          this.setToSteps();
          return true;
        } else if (this.lightbox > -1 && this.formIsSet === false) {
          this.setNonSteps();
        }
      }

      this.autofillMultipleForms();
      return undefined;
    }
  },

  watch: {
    lightboxToggled() {
      if (!this.form) {
        MktoForms2.whenReady((form) => {
          if (form.getId() === Number(this.id)) {
            this.form = form;
            this.initLightboxToggled();
          }
        });
      } else {
        this.initLightboxToggled();
      }
    }
  },

  mounted() {
    if (!this.preventLoad) {
      this.loadForm();
    }

    MktoForms2.whenReady((form) => {
      if (form.getId() === Number(this.id)) {
        this.form = form;

        if (this.cta) {
          this.setCta();
        }

        if (this.redirect) {
          this.setRedirect();
        }

        if (this.confirmMessage) {
          this.setConfirmMessage(this.confirmMessage);
        }

        if (this.moveFirst) {
          this.moveFirstStep();
        }

        if (this.lightbox < 0 && this.steps) {
          this.setToSteps();
        } else if (this.lightbox < 0) {
          this.setNonSteps();
        }
      }
    });

    this.$root.marketoCountForms++;
  }
};
</script>
